<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteAt = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                    <div class="p-col p-mt-4 p-ml-3">
                        <div class="p-grid p-col">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="public_org_owner_name">{{ $t('public_org_owner_name') }}</label>
                                <InputText
                                    id="public_org_name"
                                    type="text"
                                    v-model="public_org_owner_name"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="public_org_name">{{ $t('public_org_name') }}</label>
                                <InputText
                                    id="public_org_name"
                                    type="text"
                                    v-model="public_org_name"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="permission_license">{{ $t('permission_license') }}</label>
                                <InputText
                                    id="permission_license"
                                    type="text"
                                    v-model="permission_id"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="orgRiskLevelOptions">ระดับความเสี่ยง</label>
                                <Dropdown
                                    v-model="RiskLevel_type"
                                    :options="orgRiskLevelOptions_AT"
                                    optionLabel="RiskLevel_type"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="orgRiskLevelOptions_AT">
                                        <div v-if="orgRiskLevelOptions_AT.value">
                                            <div>{{ orgRiskLevelOptions_AT.value }}</div>
                                        </div>
                                    </template>
                                    <template #option="orgRiskLevelOptions_AT">
                                        <div>{{ orgRiskLevelOptions_AT.option }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-formgrid p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="org_business_condition">ประเภทกิจการ </label>
                                <Dropdown
                                    v-model="org_business_condition"
                                    :options="orgBusinessConditionOptions_AT"
                                    optionLabel="value"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="orgBusinessConditionOptions_AT">
                                        <div v-if="orgBusinessConditionOptions_AT.value">
                                            <div>{{ orgBusinessConditionOptions_AT.value }}</div>
                                        </div>
                                    </template>
                                    <template #option="orgBusinessConditionOptions_AT">
                                        <div>{{ orgBusinessConditionOptions_AT.option }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="imp_course_name">ลักษณะการประกอบกิจการ</label>
                                <Dropdown
                                    v-model="activity_name"
                                    :options="orgBusinessDetailOptions_AT"
                                    optionLabel="activity_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="orgBusinessDetailOptions_AT">
                                        <div v-if="orgBusinessDetailOptions_AT.value">
                                            <div>{{ orgBusinessDetailOptions_AT.value }}</div>
                                        </div>
                                    </template>
                                    <template #option="orgBusinessDetailOptions_AT">
                                        <div>{{ orgBusinessDetailOptions_AT.option }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="imp_course_name">สถานภาพสถานประกอบการ</label>
                                <Dropdown
                                    v-model="org_business_status"
                                    :options="orgBusinessStatusOptions_AT"
                                    optionLabel="org_business_status"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="orgBusinessStatusOptions_AT">
                                        <div v-if="orgBusinessStatusOptions_AT.value">
                                            <div>{{ orgBusinessStatusOptions_AT.value }}</div>
                                        </div>
                                    </template>
                                    <template #option="orgBusinessStatusOptions_AT">
                                        <div>{{ orgBusinessStatusOptions_AT.option }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field-checkbox p-col-8 p-lg-6 p-mt-5">
                                <Checkbox id="check_update_info" name="check_update_info" value="1" v-model="check_update_info" />
                                <label for="check_update_info">{{ $t('imp_update_info') }}</label>
                            </div>

                            <div class="p-field p-col">
                                <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                    <!-- Doe โหลด โทรศัพท์ -->
                                    <Button
                                        v-if="window.width <= 430"
                                        @click="MobileClearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_3_search"
                                        @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />
                                    <Button
                                        v-else
                                        @click="clearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_3_search"
                                        @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />
                                    <!-- Doe โหลด โทรศัพท์ -->
                                    <Button
                                        @click="searchOrganizationInfo()"
                                        :label="$t('searchBtn')"
                                        class="p-button-info"
                                        ref="TextBox_4_search"
                                        @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer
                        :data="Data_text_Footer"
                        :checkShow="text_Footer"
                        :countItem="public_OrganizationInfo_Table.length.toLocaleString('en-US')"
                    />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? public_OrganizationInfo_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                :sortOrder="1"
                sortField="index"
                dataKey="org_id"
                ref="dt"
                :exportFilename="`ข้อมูลสถานประกอบการ-${date}`"
                :rowHover="true"
                :selection.sync="selectedOrganizationInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="handleAddClick" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div
                            class="table-header"
                            id="TABLE_EDIT"
                            style="padding: 7px"
                            v-if="selectedOrganizationInfo && selectedOrganizationInfo.length > 0"
                        >
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>
                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText 
                                    v-model="filter" 
                                    @input="search" 
                                    :placeholder="$t('searchHeader')"
                                    ref="searchInput" 
                                />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText 
                                    disabled 
                                    v-model="filter" 
                                    :placeholder="$t('searchHeader')" 
                                />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedOrganizationInfo.length === public_OrganizationInfo_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedOrganizationInfo.some((item) => item.org_id === slotProps.data.org_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>

                <!--Doe : เพิ่มลำดับ 2/4-->
                <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div class="table_row" v-if="columns_index == true">
                            {{ dataTable.data.index }}
                        </div>
                    </template>
                </Column>

                <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                <!-- :sortable="true" -->

                <Column field="org_owner_name" :header="'ชื่อผู้ประกอบการ'" :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div class="table_row">
                            {{ dataTable.data.org_owner_name }}
                        </div>
                    </template>
                </Column>

                <Column field="org_name" :header="$t('public_org_name')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div>
                            {{ dataTable.data.org_name }}
                        </div>
                    </template>
                </Column>

                <Column
                    field="org_location"
                    :header="$t('public_org_location')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>
                            {{ dataTable.data.org_location }}
                        </div>
                    </template>
                </Column>

                <Column
                    field="organize_contact_phone"
                    :header="$t('public_org_tel')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>{{ dataTable.data.organize_contact_phone }}</div>
                    </template>
                </Column>

                <Column
                    field="organize_contact_mobile"
                    :header="$t('public_org_mobile')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>{{ dataTable.data.organize_contact_mobile }}</div>
                    </template>
                </Column>

                <Column
                    field="org_coordinator_name"
                    :header="$t('public_org_co_name')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>{{ dataTable.data.org_coordinator_name }}</div>
                    </template>
                </Column>

                <Column field="org_lat" :header="$t('latitude')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div>{{ parseFloat(dataTable.data.org_lat).toFixed(6) }}</div>
                    </template>
                </Column>

                <Column field="org_lon" :header="$t('longitude')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div>{{ parseFloat(dataTable.data.org_lon).toFixed(6) }}</div>
                    </template>
                </Column>

                <Column field="org_id" :header="$t('hsp_license_title')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div
                            @click="
                                () => {
                                    showHspInfoModal = true;
                                    editData(dataTable.data.org_id);
                                    temp = dataTable.data.org_id;
                                }
                            "
                            style="cursor: pointer"
                        >
                            ดูรายละเอียด
                        </div>
                    </template>
                </Column>

                <Column
                    field="org_id"
                    :header="$t('factory_license_title')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div
                            @click="
                                () => {
                                    showFactoryInfoModal = true;
                                    editData(dataTable.data.org_id);
                                    temp = dataTable.data.org_id;
                                }
                            "
                            style="cursor: pointer"
                        >
                            ดูรายละเอียด
                        </div>
                    </template>
                </Column>

                <Column
                    field="activity_name"
                    :header="$t('org_business_detail')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>{{ dataTable.data.activity_name }}</div>
                    </template>
                </Column>

                <Column
                    field="org_business_status"
                    :header="$t('org_business_status')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>{{ dataTable.data.org_business_status }}</div>
                    </template>
                </Column>

                <Column
                    field="risk_level"
                    :header="$t('org_risk_level')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>{{ dataTable.data.risk_level }}</div>
                    </template>
                </Column>

                <Column field="org_province" :header="$t('province')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div>{{ dataTable.data.org_province }}</div>
                    </template>
                </Column>

                <Column field="org_amphur" :header="$t('amphur')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div>{{ dataTable.data.org_amphur }}</div>
                    </template>
                </Column>

                <Column field="org_tambon" :header="$t('tambon')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div>{{ dataTable.data.org_tambon }}</div>
                    </template>
                </Column>

                <Column field="fs_tname" :header="$t('ira_FireStation')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                    <template #body="dataTable">
                        <div>{{ dataTable.data.fs_tname }}</div>
                    </template>
                </Column>

                <Column
                    field="response_organize"
                    :header="$t('ira_DistrictOffice')"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>{{ dataTable.data.response_organize }}</div>
                    </template>
                </Column>

                <Column
                    field="date_create"
                    :header="'วันที่สร้างข้อมูล'"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>
                            {{ formatThaiDate(dataTable.data.date_create) }}
                        </div>
                    </template>
                </Column>

                <Column
                    field="date_update"
                    :header="'วันที่ปรับปรุงข้อมูลล่าสุด'"
                    :sortable="true"
                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                >
                    <template #body="dataTable">
                        <div>
                            {{ formatThaiDate(dataTable.data.date_update) }}
                        </div>
                    </template>
                </Column>

                <Column
                    :header="$t('controlTable')"
                    :headerStyle="table_headerStyle"
                    :bodyStyle="table_bodyStyle"
                    v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                >
                    <template #body="dataTable">
                        <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
                            <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                <Button
                                    @click="
                                        organizationInfoModal = true;
                                        isEditMode = false;
                                        editData(dataTable.data.org_id);
                                        temp = dataTable.data.org_id;
                                    "
                                    icon="pi pi-pencil"
                                    :label="table_editBTN"
                                    class="p-button-rounded p-button-warning"
                                />
                            </div>
                            <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                <Button
                                    @click="
                                        temp = dataTable.data.org_id;
                                        deleteAt = '';
                                        alertDisplay(temp, deleteAt);
                                    "
                                    icon="pi pi-trash"
                                    :label="table_deleteBTN"
                                    class="p-button-rounded p-button-danger"
                                />
                            </div>
                        </div>
                        <div v-else>
                            {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="organizationInfoModal"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- Loading Spinner -->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                    </div>
                </div>
                <!-- End Loading Spinner -->
                <label>{{ $t('io_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-grid">
                        <!-- org_owner_name Field -->
                        <div class="p-field p-col">
                            <label for="org_owner_name">ชื่อผู้ประกอบการ <span class="required-input">*</span></label>
                            <InputText
                                id="org_owner_name"
                                type="text"
                                v-model="org_owner_name"
                                autofocus
                                required="true"
                                :class="{ 'p-invalid': error_org_owner_name && !org_owner_name }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_21', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_org_owner_name && !org_owner_name"> กรุณากรอกชื่อผู้ประกอบการ </small>
                        </div>

                        <!-- org_name Field -->
                        <div class="p-field p-col">
                            <label for="org_name">{{ $t('public_org_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="org_name"
                                type="text"
                                v-model="org_name"
                                required="true"
                                :class="{ 'p-invalid': error_org_name && !org_name }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_org_name && !org_name"> กรุณากรอกชื่อสถานประกอบการ </small>
                        </div>

                        <!-- fireStation Field -->
                        <div class="p-field p-col">
                            <label for="fireStation">สถานีดับเพลิงและกู้ภัย</label>
                            <Dropdown
                                v-model="FireStationSelected"
                                :options="FireStationOptions_AT"
                                optionLabel="fs_tname"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="FireStationOptions_AT">
                                    <div v-if="FireStationOptions_AT.value">
                                        <div>{{ FireStationOptions_AT.value.fs_tname }}</div>
                                    </div>
                                    <span v-else>{{ FireStationOptions_AT.placeholder }}</span>
                                </template>
                                <template #option="FireStationOptions_AT">
                                    <div>{{ FireStationOptions_AT.option.fs_tname }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>

                    <div class="p-grid p-col-12 p-lg-12 p-mt-2">
                        <!-- io_location_detail Field -->
                        <div class="p-field p-col p-6">
                            <label for="io_location_detail">ที่อยู่ <span class="required-input">*</span></label>
                            <InputText
                                id="io_location_detail"
                                type="text"
                                v-model="io_location_detail"
                                required="true"
                                :class="{ 'p-invalid': error_io_location_detail && !io_location_detail }"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_io_location_detail && !io_location_detail"> กรุณากรอกที่อยู่ </small>
                        </div>

                        <div class="p-field p-col p-lg-1">
                            <label for="horse_power">{{ $t('horse_power') }}</label>
                            <InputText
                                id="horse_power"
                                type="text"
                                v-model="horse_power"
                                required="true"
                                :class="{ 'p-invalid': error_horse_power && !horse_power }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_horse_power && !horse_power"> กรุณากรอกรายละเอียด </small>
                        </div>

                        <div class="p-field p-col p-lg-1">
                            <label for="total_worker">{{ $t('total_worker') }}</label>
                            <InputText
                                id="total_worker"
                                type="text"
                                v-model="total_worker"
                                required="true"
                                :class="{ 'p-invalid': error_total_worker && !total_worker }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_total_worker && !total_worker"> กรุณากรอกรายละเอียด </small>
                        </div>

                        <div class="p-field p-col p-lg-1">
                            <label for="men_worker">{{ $t('men_worker') }}</label>
                            <InputText
                                id="men_worker"
                                type="text"
                                v-model="men_worker"
                                required="true"
                                :class="{ 'p-invalid': error_men_worker && !men_worker }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_men_worker && !men_worker"> กรุณากรอกรายละเอียด </small>
                        </div>

                        <div class="p-field p-col p-lg-1">
                            <label for="women_worker">{{ $t('women_worker') }}</label>
                            <InputText
                                id="women_worker"
                                type="text"
                                v-model="women_worker"
                                required="true"
                                :class="{ 'p-invalid': error_women_worker && !women_worker }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_women_worker && !women_worker"> กรุณากรอกรายละเอียด </small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <!-- Province Field -->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="io_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                optionLabel="province_name"
                                @change="someHandler('ch-province')"
                                :class="{ 'p-invalid': error_io_selectedProvince && !io_selectedProvince }"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_io_selectedProvince && !io_selectedProvince">
                                {{ $t('io_selectedProvince_validate') }}
                            </small>
                        </div>

                        <!-- Amphur Field -->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="io_isDisabledAmphur == 1"
                                v-model="io_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                :class="{ 'p-invalid': error_io_selectedAmphur && !io_selectedAmphur }"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_io_selectedAmphur && !io_selectedAmphur">
                                {{ $t('io_selectedAmphur_validate') }}
                            </small>
                        </div>

                        <!-- Tambon Field -->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="io_isDisabledTambon == 1"
                                v-model="io_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                :class="{ 'p-invalid': error_io_selectedTambon && !io_selectedTambon }"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_io_selectedTambon && !io_selectedTambon">
                                {{ $t('io_selectedTambon_validate') }}
                            </small>
                        </div>

                        <!-- Postcode Field -->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2" style="margin-top: 5px">
                            <label for="io_postcode">{{ $t('postcode') }} <span class="required-input">*</span></label>
                            <InputText id="io_postcode" type="text" v-model="io_postcode" autofocus disabled />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <!-- contact_phone_office Field -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="contact_phone_office">เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน) </label>
                            <InputText
                                id="contact_phone_office"
                                type="text"
                                v-model="contact_phone_office"
                                @input="acceptNumberPhone2"
                                ref="TextBox_13"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.right="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_14' : 'TextBox_15', 'Input')
                                "
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_15', 'Input')"
                            />
                        </div>

                        <!-- contact_phone Field -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="contact_phone">เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) </label>
                            <InputText
                                id="contact_phone"
                                type="text"
                                v-model="contact_phone"
                                @input="acceptNumberPhone"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Input')"
                            />
                        </div>

                        <div class="p-grid">
                            <div class="p-col-12">
                                <div class="p-formgrid p-grid p-col-12">
                                    <!-- imp_organize Field -->
                                    <div class="p-field p-col-7 p-lg-6 p-mt-2" style="margin-top: -5px">
                                        <label for="imp_organize">{{ $t('response_agency') }} <span class="required-input">*</span></label>
                                        <InputText
                                            id="imp_organize"
                                            type="text"
                                            v-model="imp_organize.name"
                                            disabled
                                            :class="{ 'p-invalid': error_imp_organize && !imp_organize.name }"
                                        />
                                        <small class="p-invalid" v-if="error_imp_organize && !imp_organize.name">
                                            {{ $t('imp_organize_validate') }}
                                        </small>
                                    </div>

                                    <div class="button-group">
                                        <Button
                                            @click="showOrganize_Form = true"
                                            icon="pi pi-ellipsis-h"
                                            class="p-button-secondary p-mt-5 p-mr-2"
                                            ref="TextBox_3"
                                            @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                            @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                                        />
                                        <Button
                                            @click="imp_organize = {}"
                                            icon="pi pi-times"
                                            class="p-button-danger p-mt-5"
                                            ref="TextBox_4"
                                            @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                            @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                            @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- org_coordinator_name Field -->
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="org_coordinator_name">ชื่อผู้ประสาน</label>
                            <InputText
                                id="org_coordinator_name"
                                type="text"
                                v-model="org_coordinator_name"
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_11', 'Input')"
                            />
                        </div>

                        <!-- Date Fields -->
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input">*</span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }} <span class="required-input">*</span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>

                        <!-- Risk Level Field -->
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="orgRiskLevelOptions">ระดับความเสี่ยง <span class="required-input">*</span></label>
                            <div class="p-col">
                                <Dropdown
                                    v-model="RiskLevel_type"
                                    :options="orgRiskLevelOptions_AT"
                                    optionLabel="risk_level"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                    required="true"
                                    :class="{ 'p-invalid': error_RiskLevel_type && !RiskLevel_type }"
                                >
                                    <template #value="orgRiskLevelOptions_AT">
                                        <div v-if="orgRiskLevelOptions_AT.value">
                                            <div>{{ orgRiskLevelOptions_AT.value }}</div>
                                        </div>
                                    </template>
                                    <template #option="orgRiskLevelOptions_AT">
                                        <div>{{ orgRiskLevelOptions_AT.option }}</div>
                                    </template>
                                </Dropdown>
                                <small class="p-invalid" v-if="error_RiskLevel_type && !RiskLevel_type"> กรุณาเลือกระดับความเสี่ยง </small>
                            </div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <!-- Latitude Field -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="io_lat">{{ $t('lat') }} <span class="required-input">*</span></label>
                            <InputText
                                id="io_lat"
                                type="text"
                                v-model="io_lat"
                                @input="inputMap_latlon"
                                ref="TextBox_15"
                                @keyup.left="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>

                        <!-- Longitude Field -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="io_lon">{{ $t('lon') }} <span class="required-input">*</span></label>
                            <InputText
                                id="io_lon"
                                type="text"
                                v-model="io_lon"
                                @input="inputMap_latlon"
                                ref="TextBox_16"
                                @keyup.left="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>

                        <!-- Map Button -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(io_lat, io_lon);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_17"
                                @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>
                    </div>

                    <!-- Warning for Lat/Lon -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country">
                        ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>

                    <div class="p-field-checkbox p-col-12 p-justify-end">
                        <Checkbox id="imp_update_info" name="imp_update_info" value="1" v-model="imp_update_info" />
                        <label for="imp_update_info">{{ $t('imp_update_info') }}</label>
                    </div>

                    <hr />

                    <!-- HSP License Table -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-10">
                            <label for="disasterOptions">ใบอนุญาตประกอบกิจการที่เป็นอันตรายต่อสุขภาพ</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <Button
                                @click="showHspLicenseModal = true"
                                icon="pi pi-plus"
                                :label="isEditMode ? $t('editBtn') : $t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_18"
                                @keyup.left="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_19', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_19', 'Button')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-mt-2">
                            <DataTable
                                :value="hspTableData"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="hsp_license_id" :header="$t('permission_license')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.hsp_license_id }}
                                    </template>
                                </Column>
                                <Column field="hsp_expire_date" :header="$t('license_date_expire')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ formatThaiDate(dataTable.data.hsp_expire_date) }}
                                    </template>
                                </Column>
                                <Column field="hsp_type" :header="$t('license_type')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.hsp_type }}
                                    </template>
                                </Column>

                                <Column field="hsp_license_sequence" :header="$t('ลำดับ')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.hsp_license_sequence }}
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <hr />

                    <!-- Factory License Table -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-10">
                            <label for="disasterOptions">ใบอนุญาตประกอบกิจการโรงงาน</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <Button
                                @click="showFactoryLicense = true"
                                icon="pi pi-plus"
                                :label="isEditMode ? $t('editBtn') : $t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_18"
                                @keyup.left="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_19', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_19', 'Button')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-mt-2">
                            <DataTable
                                :value="factoryTableData"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="factory_license_id" :header="$t('permission_license')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.factory_license_id }}
                                    </template>
                                </Column>
                                <Column field="factory_detail" :header="$t('factory_business_status')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.factory_detail }}
                                    </template>
                                </Column>

                                <Column field="factory_license_sequence" :header="$t('ลำดับ')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.factory_license_sequence }}
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <hr />

                    <!-- Org Business Detail Table -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-10 p-mt-2">
                            <label>ลักษณะการประกอบกิจการ</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2 p-mt-2">
                            <Button
                                @click="showOrgBusinessDetail = true"
                                icon="pi pi-plus"
                                :label="isEditMode ? $t('editBtn') : $t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_19"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_20', 'Button')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-mt-2">
                            <DataTable
                                :value="orgBusinessDetailTableData"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                dataKey="id"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="org_business_condition" :header="$t('org_business_type')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data?.org_business_condition || '-' }}
                                    </template>
                                </Column>
                                <Column field="activity_name" :header="$t('org_business_detail')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data?.activity_name || '-' }}
                                    </template>
                                </Column>
                                <Column field="org_business_status" :header="$t('org_business_status')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data?.org_business_status || '-' }}
                                    </template>
                                </Column>
                                <Column field="remark" :header="$t('remark')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data?.remark || '-' }}
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- Footer Buttons -->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_20"
                    @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_21', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_19', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_20"
                    @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_21', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_19', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="isEditMode ? updatePublicOrganization() : savePublicOrganization()"
                    ref="TextBox_21"
                    @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_19', 'Button')"
                />
            </template>
        </Dialog>

        <template>
            <Dialog
                :modal="true"
                :header="$t('hsp_license_title_add')"
                :visible.sync="showHspLicenseModal"
                :style="{ width: '80%' }"
                :contentStyle="{ 'overflow-y': 'scroll' }"
            >
                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                    <div class="p-formgrid p-grid p-mb-3">
                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                            <label for="hsp_license_id">เลขที่ใบอนุญาต <span class="required-input">*</span></label>
                            <InputText
                                id="hsp_license_id"
                                type="text"
                                v-model="hsp_license_id"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_courseSelected && !hsp_license_id">{{ $t('itc_course_name_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                            <label for="hsp_expire_date">วันหมดอายุ <span class="required-input">*</span></label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :locale="th"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                v-model="hsp_expire_date"
                                id="hsp_expire_date"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                            <label for="hsp_type">ประเภท<span class="required-input">*</span></label>
                            <InputText
                                id="hsp_type"
                                type="text"
                                v-model="hsp_type"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_courseSelected && !hsp_type">{{ $t('itc_course_name_validate') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                            <label for="hsp_license_id">ลำดับ<span class="required-input">*</span></label>
                            <InputText
                                id="hsp_license_sequence"
                                type="text"
                                v-model="hsp_license_sequence"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_courseSelected && !hsp_license_sequence">{{ $t('itc_course_name_validate') }}</small>
                        </div>

                        <div class="p-field p-col-3 p-lg-1" style="width: 6rem">
                            <Button :label="$t('clearBtn')" class="p-button-clear p-mb-2 p-mt-5" @click="clearHspLicense()" />
                        </div>
                        <div class="p-field p-col-3 p-lg-1" style="width: 6rem; margin-left: 10px">
                            <Button
                                @click="isEditMode ? updateHspLicense() : saveHspLicense()"
                                :label="$t('selectBtn')"
                                class="p-button-success p-mb-2 p-mt-5"
                            />
                        </div>
                    </div>
                </div>
                <!-- Course detail -->
                <DataTable
                    :value="hspTableData"
                    :scrollable="true"
                    scrollHeight="500px"
                    :paginator="true"
                    :rows="5"
                    :rowHover="true"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 20, 50]"
                    currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                >
                    <template #empty>{{ $t('TableEmpty') }}</template>
                    <Column field="hsp_license_id" :header="$t('permission_license')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.hsp_license_id }}
                        </template>
                    </Column>
                    <Column field="hsp_expire_date" :header="$t('license_date_expire')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ formatThaiDate(dataTable.data.hsp_expire_date) }}
                        </template>
                    </Column>
                    <Column field="hsp_type" :header="$t('license_type')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.hsp_type }}
                        </template>
                    </Column>

                    <Column field="hsp_license_sequence" :header="$t('ลำดับ')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.hsp_license_sequence }}
                        </template>
                    </Column>
                </DataTable>
            </Dialog>
        </template>

        <template>
            <Dialog
                :modal="true"
                :header="$t('hsp_license_title')"
                :visible.sync="showHspInfoModal"
                :style="{ width: '80%' }"
                :contentStyle="{ 'overflow-y': 'scroll' }"
            >
                <DataTable :value="hspTableData" :scrollable="true" scrollHeight="500px" :rowHover="true" :style="{ margin: '20px' }">
                    <template #empty>{{ $t('TableEmpty') }}</template>
                    <Column field="hsp_license_id" :header="$t('permission_license')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.hsp_license_id }}
                        </template>
                    </Column>
                    <Column field="hsp_expire_date" :header="$t('license_date_expire')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ formatThaiDate(dataTable.data.hsp_expire_date) }}
                        </template>
                    </Column>
                    <Column field="hsp_type" :header="$t('license_type')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.hsp_type }}
                        </template>
                    </Column>

                    <Column field="hsp_license_sequence" :header="$t('ลำดับ')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.hsp_license_sequence }}
                        </template>
                    </Column>
                </DataTable>
            </Dialog>
        </template>

        <template>
            <Dialog
                :modal="true"
                :header="$t('factory_license_title')"
                :visible.sync="showFactoryInfoModal"
                :style="{ width: '80%' }"
                :contentStyle="{ 'overflow-y': 'scroll' }"
            >
                <DataTable :value="factoryTableData" :scrollable="true" scrollHeight="500px" :rowHover="true" :style="{ margin: '20px' }">
                    <template #empty>{{ $t('TableEmpty') }}</template>
                    <Column field="factory_license_id" :header="$t('permission_license')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.factory_license_id }}
                        </template>
                    </Column>
                    <Column field="factory_detail" :header="$t('factory_business_status')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.factory_detail }}
                        </template>
                    </Column>

                    <Column field="factory_license_sequence" :header="$t('ลำดับ')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.factory_license_sequence }}
                        </template>
                    </Column>
                </DataTable>
            </Dialog>
        </template>
        <template>
            <Dialog
                :modal="true"
                :header="$t('factory_license_title_add')"
                :visible.sync="showFactoryLicense"
                :style="{ width: '80%' }"
                :contentStyle="{ 'overflow-y': 'scroll' }"
            >
                <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                    <div class="p-formgrid p-grid p-mb-3">
                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                            <label for="factory_license_id">เลขที่ใบอนุญาต <span class="required-input">*</span></label>
                            <InputText
                                id="factory_license_id"
                                type="text"
                                v-model="factory_license_id"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_courseSelected && !factory_license_id">{{ $t('itc_course_name_validate') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                            <label for="factory_detail">ประกอบกิจการ<span class="required-input">*</span></label>
                            <InputText
                                id="factory_detail"
                                type="text"
                                v-model="factory_detail"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_courseSelected && !factory_detail">{{ $t('itc_course_name_validate') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-6 p-mb-2">
                            <label for="factory_license_id">ลำดับ <span class="required-input">*</span></label>
                            <InputText
                                id="factory_license_sequence"
                                type="text"
                                v-model="factory_license_sequence"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_courseSelected && !factory_license_sequence">{{
                                $t('itc_course_name_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-3 p-lg-1" style="width: 6rem">
                            <Button :label="$t('clearBtn')" class="p-button-clear p-mb-2 p-mt-5" @click="clearFactoryLicense()" />
                        </div>
                        <div class="p-field p-col-3 p-lg-1" style="width: 6rem; margin-left: 10px">
                            <Button
                                @click="isEditMode ? updateFactoryLicense() : saveFactoryLicense()"
                                :label="$t('selectBtn')"
                                class="p-button-success p-mb-2 p-mt-5"
                            />
                        </div>
                    </div>
                </div>
                <!-- Course detail -->
                <DataTable
                    :value="factoryTableData"
                    :scrollable="true"
                    scrollHeight="500px"
                    :paginator="true"
                    :rows="5"
                    :rowHover="true"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 20, 50]"
                    currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                >
                    <template #empty>{{ $t('TableEmpty') }}</template>
                    <Column field="factory_license_id" :header="$t('permission_license')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.factory_license_id }}
                        </template>
                    </Column>
                    <Column field="factory_detail" :header="$t('factory_business_status')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.factory_detail }}
                        </template>
                    </Column>

                    <Column field="factory_license_sequence" :header="$t('ลำดับ')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.factory_license_sequence }}
                        </template>
                    </Column>
                </DataTable>
            </Dialog>
        </template>

        <Dialog
            :modal="true"
            :header="$t('org_business_detail_title_add')"
            :visible.sync="showOrgBusinessDetail"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
        >
            <div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-lg-6 p-mb-2">
                        <label for="org_business_condition">ประเภทกิจการ</label>
                        <Dropdown
                            v-model="org_business_condition"
                            :options="orgBusinessConditionOptions_AT"
                            optionLabel="value"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="orgBusinessConditionOptions_AT">
                                <div v-if="orgBusinessConditionOptions_AT.value">
                                    <div>{{ orgBusinessConditionOptions_AT.value }}</div>
                                </div>
                            </template>
                            <template #option="orgBusinessConditionOptions_AT">
                                <div>{{ orgBusinessConditionOptions_AT.option }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-6 p-mb-2">
                        <label for="imp_course_name">ลักษณะการประกอบกิจการ</label>
                        <Dropdown
                            v-model="activity_name"
                            :options="orgBusinessDetailOptions_AT"
                            optionLabel="value"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="orgBusinessDetailOptions_AT">
                                <div v-if="orgBusinessDetailOptions_AT.value">
                                    <div>{{ orgBusinessDetailOptions_AT.value }}</div>
                                </div>
                            </template>
                            <template #option="orgBusinessDetailOptions_AT">
                                <div>{{ orgBusinessDetailOptions_AT.option }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-6 p-mb-2">
                        <label for="imp_course_name">สถานภาพสถานประกอบการ</label>
                        <Dropdown
                            v-model="org_business_status"
                            :options="orgBusinessStatusOptions_AT"
                            optionLabel="value"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="orgBusinessStatusOptions_AT">
                                <div v-if="orgBusinessStatusOptions_AT.value">
                                    <div>{{ orgBusinessStatusOptions_AT.value }}</div>
                                </div>
                            </template>
                            <template #option="orgBusinessStatusOptions_AT">
                                <div>{{ orgBusinessStatusOptions_AT.option }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-6 p-mb-2">
                        <label for="remark">ข้อมูลเพิ่มเติม <span class="required-input">*</span></label>
                        <InputText
                            id="remark"
                            type="text"
                            v-model="remark"
                            ref="TextBox_8"
                            @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                            @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                        />
                        <small class="p-invalid" v-if="error_courseSelected && !factory_sequence">{{ $t('itc_course_name_validate') }}</small>
                    </div>

                    <div class="p-field p-col-3 p-lg-1" style="width: 6rem">
                        <Button :label="$t('clearBtn')" class="p-button-clear p-mb-2 p-mt-5" @click="clearOrgBusinessDetail()" />
                    </div>
                    <div class="p-field p-col-3 p-lg-1" style="width: 6rem; margin-left: 10px">
                        <Button
                            @click="isEditMode ? updateOrgBusinessDetail() : saveOrgBusinessDetail()"
                            :label="$t('selectBtn')"
                            class="p-button-success p-mb-2 p-mt-5"
                        />
                    </div>
                </div>
            </div>
            <!-- Course detail -->
            <DataTable
                :value="orgBusinessDetailTableData"
                :scrollable="true"
                scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <template #empty>{{ $t('TableEmpty') }}</template>
                <Column field="org_business_condition" :header="$t('org_business_type')" :sortable="true" headerStyle="width: 15rem">
                    <template #body="dataTable">
                        {{ dataTable.data?.org_business_condition || '-' }}
                    </template>
                </Column>
                <Column field="activity_name" :header="$t('org_business_detail')" :sortable="true" headerStyle="width: 15rem">
                    <template #body="dataTable">
                        {{ dataTable.data?.activity_name || '-' }}
                    </template>
                </Column>
                <Column field="org_business_status" :header="$t('org_business_status')" :sortable="true" headerStyle="width: 15rem">
                    <template #body="dataTable">
                        {{ dataTable.data?.org_business_status || '-' }}
                    </template>
                </Column>

                <Column field="remark" :header="$t('remark')" :sortable="true" headerStyle="width: 15rem">
                    <template #body="dataTable">
                        {{ dataTable.data?.remark || '-' }}
                    </template>
                </Column>
            </DataTable>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px', overflow: 'auto' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/8  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- Doe เพิ่มหมุด map V.2 4/8  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" autofocus />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Image -->
        <Dialog :modal="true" :header="'รูปภาพหน่วยงาน'" :visible.sync="displayImageModal" :style="{ width: '400px' }">
            <div class="img-content p-mt-5 p-mb-5" style="text-align: center">
                <img :src="imgTable" alt="" v-if="imgTable" />
                <div v-else class="p-text-center">{{ $t('NoImageEquipment') }}</div>
            </div>
        </Dialog>

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../PublicOrganizeTableForm.vue';
import organizeTable from '../../Report/PublicOrganizeMultiSelectTaable.vue';
import axios from 'axios';

import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-organization',
    components: {
        organizeTable,
        organizeForm,

        mapArea,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            horse_power: '',
            total_worker: '',
            men_worker: '',
            women_worker: '',
            error_horse_power: false,
            error_total_worker: false,
            error_men_worker: false,
            error_women_worker: false,
            check_update_info: false,
            imp_update_info_date_save: '',
            imp_update_info_date: '',
            imp_update_info: [],
            showFactoryInfoModal: false,
            showHspInfoModal: false,
            ev_station_brand: '',
            service_provider: '',
            ev_station_status: '',
            error_fireStation: false,

            error_org_owner_name: false,
            error_io_location_detail: false,
            error_org_coordinator_name: false,
            error_RiskLevel_type: false,
            error_contact_phone_office: false,
            error_contact_phone_mobile: false,

            response_organize: [],
            imp_organize: { name: '' },
            permission_id: '',
            error_imp_organize: false,

            public_org_owner_name: '',
            org_id: null,
            selectedData: '',
            isEditMode: false,
            columns_org_owner_name: '',
            columns_organize_contact_mobile: '',
            columns_org_coordinator_name: '',
            columns_org_lat: '',
            columns_org_lon: '',
            columns_hsp_license_id: '',
            columns_hsp_license_sequence: '',
            columns_hsp_expire_date: '',
            columns_hsp_type: '',
            columns_sequence: '',
            columns_factory_license_id: '',
            columns_factory_license_sequence: '',
            columns_factory_detail: '',
            columns_factory_sequence: '',
            columns_condition_name: '',
            columns_activity_name: '',
            colums_remark: '',
            columns_status_name: '',
            columns_risk_name: '',
            columns_org_province: '',
            columns_org_amphur: '',
            columns_org_tambon: '',
            columns_fs_tname: '',
            columns_organize_name: '',
            columns_org_name: '',
            columns_org_location: '',

            date: moment().locale('th').add(543, 'year').format('l'),
            date_yearRange: new Date(),

            ifs_FireStation: '',
            error_ifs_FireStation: false,

            // Doe เพิ่ม สถานีดับเพลิงและกู้ภัย
            FireStationOptions: [],
            FireStationSelected: null,
            error_FireStation: false,
            FireStationOptions_AT: [],
            FireStationOptions_Form: [],

            // ifh_FireStationOptions:[],
            ifh_FireStationSelected: null,
            error_ifh_FireStationSelected: false,

            remark: '',
            org_business_condition: null,
            activity_name: null,
            org_business_status: null,
            risk_level: null,

            orgBusinessDetailTableData: [],
            showOrgBusinessDetail: false,

            error_courseSelected: false,
            orgBusinessConditionOptions_AT: ['เดิม', 'ใหม่'],
            orgBusinessDetailOptions_AT: [
                'การจัดเก็บ การผลิต การสะสม การขนส่งสารเคมีและวัตถุอันตราย',
                'การใช้สารเคมีและวัตถุอันตรายในกระบวนการผลิต',
                'อื่นๆ*'
            ],
            orgBusinessStatusOptions_AT: ['ประกอบกิจการปกติ', 'หยุดประกอบกิจการชั่วคราว(แต่ยังต่อใบอนุญาตอยู่)', 'เลิกประกอบกิจการ', 'อื่นๆ*'],
            orgRiskLevelOptions_AT: ['ยอมรับได้', 'ยอมรับไม่ได้'],

            factory_license_id: '',
            factory_license_sequence: '',
            factory_detail: '',
            factory_sequence: '',
            factoryTableData: [],
            showFactoryLicense: false,

            hsp_license_id: '',
            hsp_license_sequence: '',
            hsp_expire_date: '',
            hsp_type: '',
            hsp_sequence: '',
            hspTableData: [],
            showHspLicenseModal: false,

            orgId: null,

            FireStationOptions_fireStation: [],
            FireStationOptions_AT_fireStation: [],
            FireStationSelected_fireStation: null,
            error_FireStation_fireStation: false,

            Fire_Station: '0',

            FireStation_Make: false,
            FireStation_Null: false,
            FireStation_Null_length: false,

            Dropdown_FireStation_type: '',
            Dropdown_FireStation_boundary: '',
            Dropdown_FireStation_id: '',

            RiskLevel_type: null,

            orgRiskLevelOptions: [],

            // orgBusinessDetailOptions:[],

            orgBusinessConditionOptions: [],

            orgBusinessStatusOptions: [],

            responsiveOptions: [
                {
                    breakpoint: '1024px',
                    numVisible: 5
                },
                {
                    breakpoint: '768px',
                    numVisible: 3
                },
                {
                    breakpoint: '560px',
                    numVisible: 1
                }
            ],
            displayBasic2: false,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,

            // Doe ค้นหา  2/5
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            public_OrganizationInfo_Table: [],
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,
            public_org_name: '',
            filters: {},
            temp: null,
            showOrganize: false,
            showOrganize_Form: false,

            showCommunicationModal: false,
            selectedOrganizationInfo: [],
            selectedOrganize: {},
            location_name: '',
            displayConfirmation: false,
            deleteAt: '',
            responseArea: {},
            disasterTable: {},
            communicationTable: {},
            displayMap: false,

            disaster_table: [],
            disasterOptions: [],

            organizeTypeOptions: [],
            organizeTypeSelect: null,

            header: this.$i18n.t('public_org_title_add'),
            headerCommunication: this.$i18n.t('communication_modal_title_add'),

            communication_table: [],
            communicationTypeOptions: [],
            organizationInfoModal: false,
            org_name: '',
            io_location_detail: '',
            io_selectedOrganize: {},
            io_postcode: '',
            io_selectedProvince: null,
            io_selectedAmphur: null,
            io_selectedTambon: null,
            io_isDisabledAmphur: 1,
            io_isDisabledTambon: 1,
            io_selectedDisaster: null,
            fireStation: null,
            io_lat: '',
            io_lon: '',
            org_coordinator_name: '',
            io_fax: '',
            contact_phone_office: '',
            io_website: '',
            io_contact_name: '',
            io_contact_phone: '',
            org_owner_name: '',

            communicationTypeSelect: null,
            error_communicationTypeSelect: false,
            communication_detail: '',

            error_io_selectedProvince: false,
            error_io_selectedAmphur: false,
            error_io_selectedTambon: false,

            error_org_name: false,

            url: null,
            parentmessage_area: null,
            check_duplicate: '',
            error_email_format: false,
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            displayImageModal: false,
            imgTable: null,

            date_create_form: '',
            date_update_form: '',

            // เพิ่ม มุดmap 3/4
            //  Doe เพิ่มหมุด map V.2 5/8  -->
            latlon: {},
            PAT: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            //  Doe เพิ่มหมุด map V.2 5/8  จบ-->
            // เพิ่ม มุดmap 3/4 จบ

            iev_phone: [],
            contact_phone: '',
            contact_phone_office_ext: '',

            error_contact_phone: false,

            loading: false,

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'ต้นสังกัด',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อสังกัด/หน่วยงาน',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสังกัด/หน่วยงาน',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลสถานประกอบการ',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 11,
            PDF_FontBodyVer: 8,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 30 },
                public_org_name: { cellWidth: 68 },
                system_name: { cellWidth: 55 },
                text_tel_detail: { cellWidth: 50 },
                main_name: { cellWidth: 50 },
                organize_lat: { cellWidth: 45 },
                organize_lon: { cellWidth: 45 },
                organize_contact_name: { cellWidth: 50 },
                date_create_ddmmyy: { cellWidth: 56 },
                date_update_ddmmyy: { cellWidth: 52 }

                // public_org_name:{cellWidth:75},
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 10,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 30 },
                // organize_contact_phone: {cellWidth: 70},
                text_tel_detail: { cellWidth: 60 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อผู้ประกอบการ', dataKey: 'org_owner_name' },
                { title: 'ชื่อสถานประกอบการ', dataKey: 'org_name' },
                { title: 'ที่อยู่', dataKey: 'org_location' },
                { title: 'เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)', dataKey: 'organize_contact_phone' },
                { title: 'เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)', dataKey: 'organize_contact_mobile' },
                { title: 'ชื่อผู้ประสาน', dataKey: 'org_coordinator_name' },
                { title: 'ละติจูด', dataKey: 'org_lat' },
                { title: 'ลองจิจูด', dataKey: 'org_lon' },
                { title: 'เลขที่ใบอนุญาตประกอบกิจการที่เป็นอันตรายต่อสุขภาพ', dataKey: 'hsp_license_id' },
                { title: 'เลขที่ใบอนุญาตประกอบกิจการโรงงาน', dataKey: 'factory_license_id' },
                { title: 'ลักษณะการประกอบกิจการ', dataKey: 'org_business_condition' },
                { title: 'สถานภาพสถานประกอบการ', dataKey: 'org_business_status' },
                { title: 'ระดับความเสี่ยง', dataKey: 'risk_level' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_img: true,
            columns_public_org_name: true,
            columns_system_name: true,
            columns_main_name: true,
            columns_organize_location: true,
            columns_organize_contact_name: true,
            columns_organize_contact_phone: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'organize_image';
                        });

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'organize_image';
                        });

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        showHspLicenseModal(val) {
            if (val == true) {
                if (this.hspTableData.length > 0) {
                    this.parentmessage_area = this.hspTableData;
                } else {
                    this.parentmessage_area = [];
                }
            }
        },

        // แก้ไข สื่อสาร 2/3
        showCommunicationModal(val) {
            if (val == '') {
                this.clearDataCommunication();
            } else {
                this.FocusRef_delay('TextBox_1_Communication', 'Input');
            }
        },

        async organizationInfoModal(val) {
            if (this.isEditMode == false) {
                this.header = this.$i18n.t('public_org_title_add');
            }

            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            // console.log('this.isEditMode = ' + this.isEditMode);
            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.org_name != '' &&
                    this.fireStation != null &&
                    this.io_selectedProvince != null &&
                    this.imp_organize.name != undefined
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.imp_organize = {};
                            this.error_imp_organize = false;
                            this.org_name = '';
                            this.io_location_detail = '';
                            this.org_owner_name = '';
                            this.fireStation = null;
                            this.io_selectedOrganize = {};
                            this.io_selectedProvince = null;
                            this.contact_phone_office = '';
                            this.io_fax = '';
                            this.org_coordinator_name = '';
                            (this.org_business_condition = ''), (this.business_activity = ''), (this.io_website = '');
                            this.io_contact_name = '';
                            this.io_contact_phone = '';
                            this.io_lat = '';
                            this.io_lon = '';
                            this.io_selectedDisaster = null;
                            this.orgBusinessDetailTableData = [];
                            this.hspTableData = [];
                            this.factoryTableData = [];
                            this.communication_table = [];
                            this.error_org_name = false;
                            this.error_fireStation = false;
                            this.error_io_selectedProvince = false;
                            this.error_io_selectedAmphur = false;
                            this.error_io_selectedTambon = false;
                            this.error_email_format = false;
                            this.url = null;
                            this.organizationInfoModal = false;
                            (this.horse_power = ''),
                                (this.total_worker = ''),
                                (this.men_worker = ''),
                                (this.women_worker = ''),
                                (this.total_worker = '');
                            this.men_worker = '';
                            this.women_worker = '';

                            (this.org_business_condition = ''),
                                (this.activity_name = ''),
                                (this.org_business_status = ''),
                                (this.risk_level = ''),
                                (this.remark = ''),
                                (this.contact_phone = '');
                            this.contact_phone_office = '';
                            this.contact_phone_office_ext = '';

                            this.error_contact_phone = false;
                            this.error_contact_phone_office = false;
                            this.error_contact_phone_office_ext = false;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;

                            this.date_create_form = '';
                            this.date_update_form = '';
                        } else {
                            this.organizationInfoModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-01' }
                        })
                        .then((response) => {
                            (this.organizeTypeOptions = response.data.data),
                                this.organizeTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });

                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.imp_organize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-01' }
                    })
                    .then((response) => {
                        this.organizeTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-01' }
                    })
                    .then((response) => {
                        this.organizeTypeOptions = response.data.data;
                    });

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-province' }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterOptions = response.data.data;
                    });

                if (this.selectedData == '') {
                    const lastest = new Date();
                    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(lastest);
                    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(lastest);
                    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(lastest);
                    var ye_th = Number(ye) + 543;
                    this.imp_update_info_date = `${da}/${mo}/${ye_th}`;
                    this.imp_update_info_date_save = `${ye}-${mo}-${da}`;
                }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.organizationInfoModal = true;
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async io_selectedProvince(val) {
            if (val != null) {
                this.io_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.io_isDisabledAmphur = 1;
                this.io_selectedAmphur = null;
            }
        },

        async io_selectedAmphur(val) {
            if (val != null) {
                this.io_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.io_isDisabledTambon = 1;
                this.io_selectedTambon = null;
            }
        },

        async io_selectedTambon(val) {
            if (val != null) {
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-postcode',
                            tambon_id: val.tambon_id
                        }
                    })
                    .then((response) => {
                        if (val.tambon_id !== null && val.tambon_id !== 'null') {
                            this.io_postcode = response.data.data.postcode;
                        }
                    });
            } else {
                this.io_postcode = '';
            }
        },

        io_selectedDisaster(val) {
            if (val != null) {
                this.disaster_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.disaster_table.push(val[i]);
                }
            }
        },

        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.public_OrganizationInfo_Table = [];
            } else {
                this.public_OrganizationInfo_Table = this.cloneTable;
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }
        // check_duplicate(val) {
        //   if (val == "duplicate organize") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลหน่วยงานไม่สำเร็จ",
        //     //   detail: "มีข้อมูลหน่วยงานนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลหน่วยงานไม่สำเร็จ",
        //           text: "มีข้อมูลหน่วยงานนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลหน่วยงาน",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลหน่วยงาน",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },

    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    
        this.fetchFireStations();
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        // this.columnsSelectorDialog = this.columnsSelector
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // this.SaveEditPDF()
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {
        generateOrgId() {
            const date = new Date();
            const dateStr = date.getFullYear() + String(date.getMonth() + 1).padStart(2, '0') + String(date.getDate()).padStart(2, '0');
            return `ORG-${dateStr}-${String(Math.floor(Math.random() * 1000000)).padStart(6, '0')}`;
        },

        generateBusinessId() {
            const date = new Date();
            const dateStr = date.getFullYear() + String(date.getMonth() + 1).padStart(2, '0') + String(date.getDate()).padStart(2, '0');
            return `BID-${dateStr}-${String(Math.floor(Math.random() * 1000000)).padStart(6, '0')}`;
        },

        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedOrganizationInfo.map((item) => ({
                    org_id: item.org_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/update/public-organization/dates?user=${userId}`, {
                    body: {
                        selectedOrganizationInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.organizationInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลสถานประกอบการจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchOrganizationInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedOrganizationInfo = [...this.public_OrganizationInfo_Table];
            } else {
                this.selectedOrganizationInfo = [];
            }
            this.$emit('selectedOrganizationInfo', this.selectedOrganizationInfo);
            // console.log('selectedOrganizationInfo', this.selectedOrganizationInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedOrganizationInfo.some((item) => item.org_id === row.org_id)) {
                    this.selectedOrganizationInfo.push(row);
                }
            } else {
                this.selectedOrganizationInfo = this.selectedOrganizationInfo.filter((item) => item.org_id !== row.org_id);
            }
            this.$emit('selectedOrganizationInfo', this.selectedOrganizationInfo);
            // console.log('selectedOrganizationInfo', this.selectedOrganizationInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.organizationInfoModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            } else {
                this.imp_organize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },
        handleAddClick() {
            this.isEditMode = false;
            this.organizationInfoModal = true;
        },

        async updatePublicOrganization() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log('org_id = ' + org_id);

            this.isEditMode = true;
            // console.log('Hello Update!');

            // // Validation for all required fields
            let hasError = false;
            if (!this.org_owner_name) {
                this.error_org_owner_name = true;
                hasError = true;
            } else {
                this.error_org_owner_name = false;
            }
            if (!this.org_name) {
                this.error_org_name = true;
                hasError = true;
            } else {
                this.error_org_name = false;
            }

            if (!this.io_location_detail) {
                this.error_io_location_detail = true;
                hasError = true;
            } else {
                this.error_io_location_detail = false;
            }

            if (!this.RiskLevel_type) {
                this.error_RiskLevel_type = true;
                hasError = true;
            } else {
                this.error_RiskLevel_type = false;
            }

            // // If any required field has an error, return and do not proceed
            if (hasError) {
                this.$fire({
                    title: 'ข้อผิดพลาด',
                    text: 'กรุณากรอกข้อมูลที่จำเป็นทั้งหมด',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            // Validation for all required fields

            if (!this.org_owner_name) {
                this.error_org_owner_name = true;
                hasError = true;
            } else {
                this.error_org_owner_name = false;
            }
            if (!this.org_name) {
                this.error_org_name = true;
                hasError = true;
            } else {
                this.error_org_name = false;
            }

            if (!this.io_location_detail) {
                this.error_io_location_detail = true;
                hasError = true;
            } else {
                this.error_io_location_detail = false;
            }

            if (!this.io_selectedProvince) {
                this.error_io_selectedProvince = true;
                hasError = true;
            } else {
                this.error_io_selectedProvince = false;
            }

            if (!this.io_selectedAmphur) {
                this.error_io_selectedAmphur = true;
                hasError = true;
            } else {
                this.error_io_selectedAmphur = false;
            }

            if (!this.io_selectedTambon) {
                this.error_io_selectedTambon = true;
                hasError = true;
            } else {
                this.error_io_selectedTambon = false;
            }

            // If any required field has an error, return and do not proceed
            if (hasError) {
                this.$fire({
                    title: 'ข้อผิดพลาด',
                    text: 'กรุณากรอกข้อมูลที่จำเป็นทั้งหมด',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                return; // Stop execution if there are validation errors
            }

            this.$fire({
                title: 'ยืนยันการอัปเดตข้อมูล',
                text: 'คุณต้องการอัปเดตข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const username = this.decodeJWT.user_username;
                        const response_organize = this.imp_organize?.name || ''; // Ensure imp_organize name is included

                        const orgBusinessDataDetail = {
                            response_organize: response_organize,
                            org_id: this.org_id,
                            org_name: this.org_name,
                            org_owner_name: this.org_owner_name,
                            org_address: this.io_location_detail,
                            org_tel: this.contact_phone_office,
                            activity_name: this.activity_name,
                            org_coordinator_name: this.org_coordinator_name,
                            io_lat: this.io_lat,
                            io_lon: this.io_lon,
                            date_create_form: currentDateString,
                            date_update_form: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: this.flag || 'active',
                            io_location_detail: this.io_location_detail,
                            contact_phone_office: this.contact_phone_office,
                            contact_phone: this.contact_phone,
                            FireStationSelected: this.FireStationSelected?.fs_tname || null,
                            io_selectedProvince: this.io_selectedProvince.province_name,
                            io_selectedAmphur: this.io_selectedAmphur.amphur_name,
                            io_selectedTambon: this.io_selectedTambon.tambon_name,
                            io_postcode: this.io_postcode,
                            RiskLevel_type: this.RiskLevel_type,
                            business_id: this.business_id,
                            check_update: this.imp_update_info || '',
                            organize_id: this.imp_organize?.id || '',
                            horse_power: this.horse_power || '',
                            total_worker: this.total_worker || '',
                            men_worker: this.men_worker || '',
                            women_worker: this.women_worker || ''
                        };

                        const hspLicense = this.hspTableData.map((hsp) => ({
                            hsp_license_id: hsp.hsp_license_id || 'hsp-' + Date.now(),
                            hsp_expire_date: formatDate(hsp.hsp_expire_date),
                            hsp_type: hsp.hsp_type,
                            hsp_license_sequence: hsp.hsp_license_sequence,
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1',
                            org_id: orgBusinessDataDetail.org_id,
                            business_id: orgBusinessDataDetail.business_id
                        }));

                        const factoryLicense = this.factoryTableData.map((factory) => ({
                            factory_license_id: factory.factory_license_id || 'factory-' + Date.now(),
                            factory_license_sequence: factory.factory_license_sequence,
                            factory_detail: factory.factory_detail,
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1',
                            org_id: orgBusinessDataDetail.org_id,
                            business_id: orgBusinessDataDetail.business_id
                        }));

                        const orgBusinessDetail = this.orgBusinessDetailTableData.map((detail) => ({
                            org_business_condition: detail.org_business_condition,
                            activity_name: detail.activity_name,
                            org_business_status: detail.org_business_status,
                            remark: detail.remark,
                            risk_level: detail.risk_level
                        }));

                        const businessLicenseData = {
                            business_id: orgBusinessDataDetail.business_id,
                            org_id: orgBusinessDataDetail.org_id,
                            factory_license_id: factoryLicense.map((fl) => fl.factory_license_id),
                            hsp_license_id: hspLicense.map((hl) => hl.hsp_license_id),
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1'
                        };

                        const payload = {
                            orgBusinessDataDetail,
                            hspLicense,
                            factoryLicense,
                            orgBusinessDetail,
                            businessLicenseData
                        };

                        // console.log('payload', payload);

                        const userId = this.getUsername();
                        this.loadingUpdate = true;
                        const response = await fetch(`${this.$url_service}/update/public/organization/data?user=${userId}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            const errorData = await response.json();
                            if (errorData.message && errorData.message.includes('duplicate')) {
                                throw new Error('มีข้อมูลซ้ำในระบบ: ' + errorData.message);
                            } else {
                                throw new Error(`Network response was not ok: ${response.statusText}`);
                            }
                        }

                        // const data = await response.json();
                        // console.log('Organization detail updated successfully:', data);

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกอัปเดตเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        }).then(() => {
                            this.searchOrganizationInfo();
                            this.organizationInfoModal = false;
                        });
                    } catch (error) {
                        console.error('Error updating organization detail:', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการอัปเดตข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingUpdate = false;
                    }
                }
            });
        },

        formatThaiDate(date) {
            if (!date) return null;
            const thaiMonths = [
                'มกราคม',
                'กุมภาพันธ์',
                'มีนาคม',
                'เมษายน',
                'พฤษภาคม',
                'มิถุนายน',
                'กรกฎาคม',
                'สิงหาคม',
                'กันยายน',
                'ตุลาคม',
                'พฤศจิกายน',
                'ธันวาคม'
            ];
            const d = new Date(date);
            const day = d.getDate();
            const month = thaiMonths[d.getMonth()];
            const year = d.getFullYear() + 543; // Convert to Thai Buddhist year
            return `${day} ${month} ${year}`;
        },
        async fetchFireStations() {
            try {
                const response = await axios.post(`${this.$url_service}/get/fire/station`);
                if (response.data.code === 'success') {
                    this.FireStationOptions_AT = response.data.data;
                } else {
                    console.error('Error fetching fire stations:', response.data);
                }
            } catch (error) {
                console.error('Server error:', error);
            }
        },
        toTimestampWithTimezone(date) {
            if (!date) return null;
            const d = new Date(date);
            return d.toISOString(); // Convert to ISO 8601 string which includes timezone information
        },

        saveOrgBusinessDetail() {
            if (this.org_business_condition && this.activity_name && this.org_business_status && this.remark) {
                this.orgBusinessDetailTableData.push({
                    org_business_condition: this.org_business_condition,
                    activity_name: this.activity_name,
                    org_business_status: this.org_business_status,
                    remark: this.remark
                });

                // console.log('orgBusinessDetailTableData', this.orgBusinessDetailTableData);

                // Clear the form fields after pushing to the table
                this.org_business_condition = null;
                this.activity_name = null;
                this.org_business_status = null;
                this.remark = '';

                // Reset any error states
                this.error_courseSelected = false;
            }
        },

        updateOrgBusinessDetail() {
            this.isEditMode = true;
            if (this.org_business_condition && this.activity_name && this.org_business_status && this.remark) {
                // Add the new entry to the existing data
                this.orgBusinessDetailTableData.push({
                    org_business_condition: this.org_business_condition,
                    activity_name: this.activity_name,
                    org_business_status: this.org_business_status,
                    remark: this.remark
                });

                // console.log('orgBusinessDetailTableData', this.orgBusinessDetailTableData);

                // Reset the form fields
                this.org_business_condition = null;
                this.activity_name = null;
                this.org_business_status = null;
                this.remark = '';

                // Reset any error states
                this.error_courseSelected = false;
            }
        },

        clearOrgBusinessDetail() {
            this.org_business_condition = null;
            this.activity_name = null;
            this.org_business_status = null;
            this.risk_level = null;
            this.remark = '';
            this.orgBusinessDetailTableData = [];
        },
        saveFactoryLicense() {
            if (this.factory_license_id && this.factory_detail && this.factory_license_sequence) {
                this.factoryTableData.push({
                    factory_license_id: this.factory_license_id,
                    factory_license_sequence: this.factory_license_sequence,
                    factory_detail: this.factory_detail
                });
                // Clear the form fields after pushing to the table
                this.factory_license_id = '';
                this.factory_license_sequence = '';
                this.factory_detail = '';

                this.error_courseSelected = false; // Clear error flag after successful save
            }
        },

        updateFactoryLicense() {
            this.isEditMode = true;
            if (this.factory_license_id && this.factory_detail && this.factory_license_sequence) {
                // Add the new entry to the existing data
                this.factoryTableData.push({
                    factory_license_id: this.factory_license_id,
                    factory_license_sequence: this.factory_license_sequence,
                    factory_detail: this.factory_detail
                });

                // Reset the form fields
                this.factory_license_id = '';
                this.factory_license_sequence = '';
                this.factory_detail = '';

                // Reset any error states
                this.error_courseSelected = false;

                // console.log('Factory license updated:', this.factoryTableData);
            }
        },

        clearFactoryLicense() {
            this.factory_license_id = '';
            this.factory_license_sequence = '';
            this.factory_detail = '';
            this.factoryTableData = [];
        },

        saveHspLicense() {
            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}`;
            }
            if (this.hsp_license_id && this.hsp_expire_date && this.hsp_type && this.hsp_license_sequence) {
                this.hspTableData.push({
                    hsp_license_id: this.hsp_license_id,
                    hsp_expire_date: formatDate(this.hsp_expire_date),
                    hsp_type: this.hsp_type,
                    hsp_license_sequence: this.hsp_license_sequence
                });

                // console.log('this.hsp_expire_date', this.hsp_expire_date);
                // Clear the form fields after pushing to the table
                this.hsp_license_id = '';
                this.hsp_license_sequence = '';
                this.hsp_expire_date = '';
                this.hsp_type = '';
            }
        },

        updateHspLicense() {
            this.isEditMode = true;

            if (this.hsp_license_id && this.hsp_expire_date && this.hsp_type && this.hsp_license_sequence) {
                // Add the new entry to the existing data
                this.hspTableData.push({
                    hsp_license_id: this.hsp_license_id,
                    hsp_license_sequence: this.hsp_license_sequence,
                    hsp_expire_date: this.hsp_expire_date,
                    hsp_type: this.hsp_type
                });

                // console.log('this.hsp_expire_date', this.hsp_expire_date);

                // Reset the form fields
                this.hsp_license_id = '';
                this.hsp_license_sequence = '';
                this.hsp_expire_date = '';
                this.hsp_type = '';

                // Reset any error states
                this.error_courseSelected = false;
            }
        },

        clearHspLicense() {
            this.hsp_license_id = '';
            this.hsp_license_sequence = '';
            this.hsp_expire_date = '';
            this.hsp_type = '';
            this.hspTableData = [];
        },

        async Fire_Form() {
            if (this.selectedData == '') {
                this.ifh_FireStationSelected = null;
            }

            // this.selectedProvince = null
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser(),
                        province_id:
                            this.ifh_selectedProvince == null
                                ? ''
                                : this.ifh_selectedProvince.province_id == 'getall'
                                ? ''
                                : this.ifh_selectedProvince.province_id,
                        amphur_id:
                            this.ira_selectedAmphur == null
                                ? ''
                                : this.ira_selectedAmphur.amphur_id == 'getall'
                                ? ''
                                : this.ira_selectedAmphur.amphur_id,
                        tambon_id:
                            this.ira_selectedTambon == null
                                ? ''
                                : this.ira_selectedTambon.tambon_id == 'getall'
                                ? ''
                                : this.ira_selectedTambon.tambon_id
                    }
                })
                .then((response) => {
                    this.FireStationOptions_Form = response.data.data;

                    // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                });
        },
        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_3_search') && !this.isFocused('TextBox_4_search')) {
                    this.searchOrganizationInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_5') &&
                    !this.isFocused('TextBox_6') &&
                    !this.isFocused('TextBox_16') &&
                    !this.isFocused('TextBox_17') &&
                    !this.isFocused('TextBox_18') &&
                    !this.isFocused('TextBox_19')
                ) {
                    this.updatePublicOrganization();
                }
            } else if (ModalName === 'Modal_Communication') {
                this.saveCommunicationData();
            }
        },

        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    (this.organizeTypeOptions = response.data.data),
                        this.organizeTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6

search() {
    // Store reference to the input element
    if (event && event.target) {
        this.searchInputRef = event.target;
    }
    
    // Cancel any existing timeout
    if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
    }
    
    // Use debounce to delay processing
    this.searchTimeout = setTimeout(() => {
        if (this.filter !== '' && this.cloneTable.length > 0) {
            const searchTerm = this.filter.toLowerCase();

            this.public_OrganizationInfo_Table = this.cloneTable.filter((item) => {
                return (
                    (item.org_owner_name && item.org_owner_name.toLowerCase().includes(searchTerm)) ||
                    (item.org_name && item.org_name.toLowerCase().includes(searchTerm)) ||
                    (item.org_location && item.org_location.toLowerCase().includes(searchTerm)) ||
                    (item.organize_contact_phone && item.organize_contact_phone.toLowerCase().includes(searchTerm)) ||
                    (item.organize_contact_mobile && item.organize_contact_mobile.toLowerCase().includes(searchTerm)) ||
                    (item.org_coordinator_name && item.org_coordinator_name.toLowerCase().includes(searchTerm)) ||
                    (item.org_lat && item.org_lat.toString().toLowerCase().includes(searchTerm)) ||
                    (item.org_lon && item.org_lon.toString().toLowerCase().includes(searchTerm)) ||
                    (item.hsp_license_id && item.hsp_license_id.toLowerCase().includes(searchTerm)) ||
                    (item.hsp_license_sequence && item.hsp_license_sequence.toLowerCase().includes(searchTerm)) ||
                    (item.hsp_expire_date && item.hsp_expire_date.toLowerCase().includes(searchTerm)) ||
                    (item.hsp_type && item.hsp_type.toLowerCase().includes(searchTerm)) ||
                    (item.factory_license_id && item.factory_license_id.toLowerCase().includes(searchTerm)) ||
                    (item.factory_license_sequence && item.factory_license_sequence.toLowerCase().includes(searchTerm)) ||
                    (item.factory_detail && item.factory_detail.toLowerCase().includes(searchTerm)) ||
                    (item.org_business_condition && item.org_business_condition.toLowerCase().includes(searchTerm)) ||
                    (item.activity_name && item.activity_name.toLowerCase().includes(searchTerm)) ||
                    (item.remark && item.remark.toLowerCase().includes(searchTerm)) ||
                    (item.org_business_status && item.org_business_status.toLowerCase().includes(searchTerm)) ||
                    (item.risk_level && item.risk_level.toLowerCase().includes(searchTerm)) ||
                    (item.org_province && item.org_province.toLowerCase().includes(searchTerm)) ||
                    (item.org_amphur && item.org_amphur.toLowerCase().includes(searchTerm)) ||
                    (item.org_tambon && item.org_tambon.toLowerCase().includes(searchTerm)) ||
                    (item.fs_tname && item.fs_tname.toLowerCase().includes(searchTerm)) ||
                    (item.org_response_organize && item.org_response_organize.toLowerCase().includes(searchTerm))
                );
            });

            // Update the index
            this.public_OrganizationInfo_Table.forEach((item, index) => {
                item['index'] = index + 1;
            });
        } else {
            this.public_OrganizationInfo_Table = [...this.cloneTable];
            this.public_OrganizationInfo_Table.forEach((item, index) => {
                item['index'] = index + 1;
            });
        }
        
        // Restore focus to input element after rendering completes
        this.$nextTick(() => {
            if (this.searchInputRef) {
                this.searchInputRef.focus();
                
                // Place cursor at the end of the text
                const length = this.searchInputRef.value.length;
                this.searchInputRef.setSelectionRange(length, length);
            }
        });
    }, 300);
},

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;

            // await this.axios
            //     .post(`${this.$url_service}/initial/organize`, {
            //         body: {
            //             topic: 'get-table',
            //             userOrg: this.checkPermission() ? null : this.getUserOrganize()
            //         }
            //     })
            //     // Doe : เพิ่ม ลำดับ 3/4
            //     .then((response) => {
            //         this.public_OrganizationInfo_Table = response.data.data;
            //         // Doe ค้นหา  4/6
            //         this.cloneTable = response.data.data;
            //         // Doe ค้นหา  4/6
            //         for (let i = 0; i < this.public_OrganizationInfo_Table.length; i++) {
            //             this.public_OrganizationInfo_Table[i]['index'] = i + 1;
            //         }
            //         // console.log("this.public_OrganizationInfo_Table",this.public_OrganizationInfo_Table)
            //         // Doe ช่องว่างใส่ ขีด
            //         this.formatData(this.public_OrganizationInfo_Table);
            //         // Doe ช่องว่างใส่ ขีด
            //     });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.public_OrganizationInfo_Table = this.cloneTable;
            } else {
                this.public_OrganizationInfo_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-01' }
                })
                .then((response) => {
                    (this.organizeTypeOptions = response.data.data),
                        this.organizeTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-04' }
                })
                .then((response) => {
                    this.communicationTypeOptions = response.data.data;
                });

            this.loading = false;
        },

        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].organize_location == null || data[index].organize_location == 'null' || data[index].organize_location == '') {
                    data[index].organize_location = '-';
                }
                if (
                    data[index].organize_contact_name == null ||
                    data[index].organize_contact_name == 'null' ||
                    data[index].organize_contact_name == ''
                ) {
                    data[index].organize_contact_name = '-';
                }
                if (
                    data[index].organize_contact_phone == null ||
                    data[index].organize_contact_phone == 'null' ||
                    data[index].organize_contact_phone == ''
                ) {
                    data[index].organize_contact_phone = '-';
                }

                if (data[index].org_business_status == null || data[index].org_business_status == 'null' || data[index].org_business_status == '') {
                    data[index].org_business_status = '-';
                }

                if (data[index].fs_tname == null || data[index].fs_tname == 'null' || data[index].fs_tname == '') {
                    data[index].fs_tname = '-';
                }

                if (
                    data[index].organize_contact_mobile == null ||
                    data[index].organize_contact_mobile == 'null' ||
                    data[index].organize_contact_mobile == ''
                ) {
                    data[index].organize_contact_mobile = '-';
                }
                if (data[index].main_name == null || data[index].main_name == 'null' || data[index].main_name == '') {
                    data[index].main_name = '-';
                }

                if (
                    data[index].org_coordinator_name == null ||
                    data[index].org_coordinator_name == 'null' ||
                    data[index].org_coordinator_name == ''
                ) {
                    data[index].org_coordinator_name = '-';
                }

                if (data[index].activity_name == null || data[index].activity_name == 'null' || data[index].activity_name == '') {
                    data[index].activity_name = '-';
                }
                if (data[index].organize_lat) {
                    data[index].organize_lat = parseFloat(data[index].organize_lat).toFixed(6);
                }
                if (data[index].organize_lon) {
                    data[index].organize_lon = parseFloat(data[index].organize_lon).toFixed(6);
                }
                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.organizationInfoModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        acceptNumberCTPhone() {
            var x = this.io_contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.io_contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },

        // acceptNumberPhone() {
        //   var x = this.contact_phone_office
        //     .replace(/\D/g, "")
        //     .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //   this.contact_phone_office = !x[2]
        //     ? x[1]
        //     : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        // },

        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.io_selectedAmphur = null;
                this.io_postcode = '';
            }
            if (message == 'ch-amphur') {
                this.io_selectedTambon = null;
                this.io_postcode = '';
            }
        },

        clearImage() {
            this.url = null;
            document.getElementById('organize_uploadImageFile').value = '';
        },

        onFileChange(e) {
            document.getElementById('organize_uploadImageFile').click();
            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    //  const imgSize = e.target.files[0]
                    // if (imgSize.size > 7340032) {
                    //   this.$fire({
                    //         type: "warning",
                    //         title:"ขนาดไฟล์ใหญ่เกินไป",
                    //         text: "กรุณาใส่เฉพาะไฟล์รูปภาพไม่เกิน 7 MB.",
                    //         timer: 3000,
                    //         confirmButtonColor: '#28B463',
                    //       });
                    //       this.clearImage()

                    // }else{
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);
                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                // var MAX_WIDTH = 150;
                                // var MAX_HEIGHT = 180;
                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('io_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                // console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        // this.$toast.add({
                        //   severity: "error",
                        //   summary: "ประเภทไฟล์ผิดพลาด",
                        //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('organize_uploadImageFile').value = '';
                    }
                    // }
                } else {
                    this.url = null;
                }
            }
        },

        // selectedOrganize_passValue(variable) {
        //   this.showOrganize = false;
        //   if (this.organizationInfoModal == false) {
        //     this.selectedOrganize = {
        //       id: variable.org_id,
        //       name: variable.public_org_name,
        //     };
        //   } else {
        //     this.io_selectedOrganize = {
        //       id: variable.org_id,
        //       name: variable.public_org_name,
        //     };
        //   }
        // },

        selectResponseArea_passValue(variable) {
            this.showHspLicenseModal = false;
            this.hspTableData = variable;
        },
        showImage(data) {
            if (data === null) {
                this.imgTable = null;
            } else if (data) {
                this.imgTable = [data];
            } else {
                this.imgTable = null;
            }
            // console.log(this.imgTable[0].data)
            // console.log("responsiveOptions",this.responsiveOptions)
            // this.displayImageModal = true;
            this.displayBasic2 = true;
        },
        selectMap_passValue(variable) {
            // this.displayMap = false;
            this.io_lat = variable.lat;
            this.io_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.io_lat",this.io_lat)
            // console.log("this.io_lon",this.io_lon)
            if (this.io_lat !== null && this.io_lon !== null && this.io_lat !== '' && this.io_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/8  -->
        async inputMap_latlon() {
            if (this.io_lat !== '' && this.io_lat !== null && this.io_lon !== '' && this.io_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.io_lat}/lon=${this.io_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.io_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.io_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.io_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.io_selectedProvince = null;
                                this.io_selectedAmphur = null;
                                this.io_selectedTambon = null;
                            }

                            // console.log("this.io_selectedProvince",this.io_selectedProvince)
                            // console.log("this.io_selectedAmphur",this.io_selectedAmphur)
                            // console.log("this.io_selectedTambon",this.io_selectedTambon)
                        } else {
                            this.io_selectedProvince = null;
                            this.io_selectedAmphur = null;
                            this.io_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.io_selectedProvince = null;
                this.io_selectedAmphur = null;
                this.io_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            // console.log("this.io_selectedProvince",this.io_selectedProvince)
            // console.log("this.io_selectedAmphur",this.io_selectedAmphur)
            // console.log("this.io_selectedTambon",this.io_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';
            if (this.io_selectedProvince) {
                this.sP.push(this.io_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.io_selectedAmphur) {
                this.sA.push(this.io_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.io_selectedProvince == null) {
                this.io_lat = '';
                this.io_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.io_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.io_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.io_lat = lat;
                        this.io_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.io_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.io_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.io_lat = lat;
                        this.io_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.io_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.io_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.io_lat = lat;
                        this.io_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.io_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.io_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.io_lat = lat;
                            this.io_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.io_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.io_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.io_lat = lat;
                            this.io_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.io_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.io_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.io_lat = lat;
                            this.io_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.io_lat = '';
                    this.io_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/8  จบ-->

        async searchOrganizationInfo() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            try {
                const response = await this.axios.post(
                    `${this.$url_service}/search/public/organization/data`,

                    {
                        public_org_owner_name: this.public_org_owner_name,
                        public_org_name: this.public_org_name,
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        permission_id: this.permission_id,
                        RiskLevel_type: this.RiskLevel_type,
                        org_business_condition: this.org_business_condition,
                        activity_name: this.activity_name,
                        org_business_status: this.org_business_status,
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        organize: this.organize_table,
                        userOrg,
                        update: this.check_update_info
                    }
                );

                // console.log('response', response);
                // Since the server now returns unique organizations, no need for additional filtering
                this.public_OrganizationInfo_Table = response.data;
                this.cloneTable = response.data;

                // console.log('this.public_OrganizationInfo_Table', this.public_OrganizationInfo_Table);

                this.public_OrganizationInfo_Table.forEach((item, index) => {
                    item['index'] = index + 1;
                });

                this.formatData(this.public_OrganizationInfo_Table);
                this.setSearchText_Footer();
                this.search();

                if (this.columns_disabled) {
                    this.public_OrganizationInfo_Table = this.cloneTable;
                } else {
                    this.public_OrganizationInfo_Table = [];
                }

                // console.log('this.cloneTable', this.cloneTable);
            } catch (error) {
                console.error('Error fetching organization info:', error);
            } finally {
                this.loading = false;
            }
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.public_org_name !== '' ||
                this.organizeTypeSelect !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'ต้นสังกัด' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อสังกัด/หน่วยงาน' && this.public_org_name !== '') {
                        element.textShow = this.public_org_name;
                    }
                    if (element.DataName === 'ประเภทสังกัด/หน่วยงาน' && this.organizeTypeSelect !== null) {
                        element.textShow = this.organizeTypeSelect.system_name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                }

                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.public_org_name !== undefined) {
                    text += element.public_org_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.deleteAt === 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            }

            try {
                const userId = this.getUsername();
                await this.axios.post(`${this.$url_service}/delete/public/organization/data?user=${userId}`, {
                    org_id: this.temp
                });

                this.displayConfirmation = false;
                this.searchOrganizationInfo();

                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลหน่วยงาน',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } catch (error) {
                console.error('Error deleting organization data:', error);
                this.$fire({
                    type: 'error',
                    title: 'ลบข้อมูลไม่สำเร็จ',
                    text: 'เกิดข้อผิดพลาดในการลบข้อมูลหน่วยงาน',
                    timer: 3000,
                    confirmButtonColor: '#E74C3C'
                });
            }
        },

        async savePublicOrganization() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.isEditMode = false;

            // // Validation for all required fields
            let hasError = false;
            if (!this.org_owner_name) {
                this.error_org_owner_name = true;
                hasError = true;
            } else {
                this.error_org_owner_name = false;
            }
            if (!this.org_name) {
                this.error_org_name = true;
                hasError = true;
            } else {
                this.error_org_name = false;
            }

            if (!this.io_location_detail) {
                this.error_io_location_detail = true;
                hasError = true;
            } else {
                this.error_io_location_detail = false;
            }

            // // If any required field has an error, return and do not proceed
            if (hasError) {
                this.$fire({
                    title: 'ข้อผิดพลาด',
                    text: 'กรุณากรอกข้อมูลที่จำเป็นทั้งหมด',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                return;
            }

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            this.$fire({
                title: 'ยืนยันการสร้างข้อมูล',
                text: 'คุณต้องการสร้างข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const username = this.decodeJWT.user_username;
                        const response_organize = this.imp_organize?.name || '';

                        const orgBusinessDataDetail = {
                            response_organize: response_organize,

                            org_name: this.org_name,
                            org_owner_name: this.org_owner_name,
                            org_address: this.io_location_detail,
                            org_tel: this.contact_phone_office,
                            activity_name: this.activity_name,
                            org_coordinator_name: this.org_coordinator_name,
                            io_lat: this.io_lat,
                            io_lon: this.io_lon,
                            date_create_form: currentDateString,
                            date_update_form: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1',
                            io_location_detail: this.io_location_detail,
                            contact_phone_office: this.contact_phone_office,
                            contact_phone: this.contact_phone,
                            FireStationSelected: this.FireStationSelected?.fs_tname || null,
                            io_selectedProvince: this.io_selectedProvince.province_name,
                            io_selectedAmphur: this.io_selectedAmphur.amphur_name,
                            io_selectedTambon: this.io_selectedTambon.tambon_name,
                            io_postcode: this.io_postcode,
                            RiskLevel_type: this.RiskLevel_type,
                            org_id: this.generateOrgId(),
                            business_id: this.generateBusinessId(),
                            check_update: this.imp_update_info || '',
                            organize_id: this.imp_organize?.id || '',
                            horse_power: this.horse_power || '',
                            total_worker: this.total_worker || '',
                            men_worker: this.men_worker || '',
                            women_worker: this.women_worker || ''
                        };

                        const hspLicense = this.hspTableData.map((hsp) => ({
                            hsp_license_id: hsp.hsp_license_id,
                            hsp_license_sequence: hsp.hsp_license_sequence,
                            hsp_expire_date: formatDate(hsp.hsp_expire_date),
                            hsp_type: hsp.hsp_type,
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1',
                            org_id: orgBusinessDataDetail.org_id,
                            business_id: orgBusinessDataDetail.business_id
                        }));

                        const factoryLicense = this.factoryTableData.map((factory) => ({
                            factory_license_id: factory.factory_license_id,
                            factory_license_sequence: factory.factory_license_sequence,
                            factory_detail: factory.factory_detail,
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1',
                            org_id: orgBusinessDataDetail.org_id,
                            business_id: orgBusinessDataDetail.business_id
                        }));

                        const orgBusinessDetail = this.orgBusinessDetailTableData.map((detail) => ({
                            org_business_condition: detail.org_business_condition,
                            activity_name: detail.activity_name || null,
                            org_business_status: detail.org_business_status,
                            risk_level: detail.risk_level,
                            remark: detail.remark
                        }));

                        const businessLicenseData = {
                            business_id: orgBusinessDataDetail.business_id,
                            org_id: orgBusinessDataDetail.org_id,
                            factory_license_id: factoryLicense.map((fl) => fl.factory_license_id),
                            hsp_license_id: hspLicense.map((hl) => hl.hsp_license_id),
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1'
                        };

                        const payload = {
                            orgBusinessDataDetail,
                            hspLicense,
                            factoryLicense,
                            orgBusinessDetail,
                            businessLicenseData
                        };

                        // console.log('payload', payload);

                        const userId = this.getUsername();

                        this.loadingCreate = true;
                        const response = await fetch(`${this.$url_service}/post/organization/detail?user=${userId}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            const errorData = await response.json();
                            if (errorData.message && errorData.message.includes('duplicate')) {
                                throw new Error('มีข้อมูลซ้ำในระบบ: ' + errorData.message);
                            } else {
                                throw new Error(`Network response was not ok: ${response.statusText}`);
                            }
                        }

                        const data = await response.json();
                        // console.log('Organization detail posted successfully:', data);

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกบันทึกเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        }).then(() => {
                            this.searchOrganizationInfo();
                            this.organizationInfoModal = false; // Add this line to close the modal after success
                        });
                    } catch (error) {
                        console.error('Error posting organization detail:', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการบันทึกข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingCreate = false;
                    }
                }
            });
        },

        async editData(org_id) {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log('Edit mode activated for org_id:', org_id);

            // Store the org_id for later use
            this.org_id = org_id;

            try {
                // console.log('Making API request...');
                const response = await this.axios.post(`${this.$url_service}/search/edit/public/organization/data`, {
                    org_id: org_id
                });

                // console.log('API response received', response);

                if (response.data && response.data.data) {
                    let data = response.data.data;

                    // console.log('Data found:', data);

                    this.selectedData = data;
                    this.imp_update_info = [data.orgBusinessDataDetail.update_info];
                    this.org_id = data.orgBusinessDataDetail.org_id || '';
                    this.org_owner_name = data.orgBusinessDataDetail.org_owner_name || '';
                    this.org_name = data.orgBusinessDataDetail.org_name || '';
                    this.horse_power = data.orgBusinessDataDetail.horse_power || '';
                    this.total_worker = data.orgBusinessDataDetail.total_worker || '';
                    this.men_worker = data.orgBusinessDataDetail.men_worker || '';
                    this.women_worker = data.orgBusinessDataDetail.women_worker || '';
                    if (
                        !data.orgBusinessDataDetail.fs_tname ||
                        data.orgBusinessDataDetail.fs_tname == null ||
                        data.orgBusinessDataDetail.fs_tname == '' ||
                        data.orgBusinessDataDetail.fs_tname == 'null' ||
                        data.orgBusinessDataDetail.fs_tname == 'undefined'
                    ) {
                        this.FireStationSelected = null;
                    } else {
                        this.FireStationSelected = { fs_tname: data.orgBusinessDataDetail.fs_tname };
                    }
                    this.io_location_detail = data.orgBusinessDataDetail.org_address || '';
                    this.io_selectedProvince = { province_name: data.orgBusinessDataDetail.org_province }; // dropdown
                    this.io_selectedAmphur = { amphur_name: data.orgBusinessDataDetail.org_amphur }; // dropdown
                    this.io_selectedTambon = { tambon_name: data.orgBusinessDataDetail.org_tambon }; // dropdown
                    this.RiskLevel_type = data.orgBusinessDataDetail.risk_level; // dropdown
                    this.io_postcode = data.orgBusinessDataDetail.org_postcode || '';
                    this.contact_phone_office = data.orgBusinessDataDetail.org_tel || '';
                    this.contact_phone = data.orgBusinessDataDetail.organize_contact_phone || '';
                    this.org_coordinator_name = data.orgBusinessDataDetail.organize_contact_mobile || '';
                    this.date_create_form = this.formatThaiDate(data.orgBusinessDataDetail.date_create) || '';
                    this.date_update_form = this.formatThaiDate(data.orgBusinessDataDetail.date_update) || '';
                    this.io_lat = data.orgBusinessDataDetail.org_lat || '';
                    this.business_id = data.orgBusinessDataDetail.business_id || '';
                    this.io_lon = data.orgBusinessDataDetail.org_lon || '';
                    this.imp_organize = {
                        name: data.orgBusinessDataDetail.response_organize || '',
                        id: data.orgBusinessDataDetail.organize_id || ''
                    };

                    // console.log('Selected Fire Station:', this.FireStationSelected);
                    // console.log('Selected Province:', this.io_selectedProvince);
                    // console.log('Selected Amphur:', this.io_selectedAmphur);
                    // console.log('Selected Tambon:', this.io_selectedTambon);

                    this.hsp_license = data.hspLicense.map((license) => ({
                        hsp_license_id: license.hsp_license_id || '',
                        hsp_license_sequence: license.hsp_license_sequence,
                        hsp_expire_date: license.hsp_expire_date || '',
                        hsp_type: license.hsp_type || ''
                    }));

                    // console.log('HSP License data:', this.hsp_license);

                    this.factory_license = data.factoryLicense.map((license) => ({
                        factory_license_id: license.factory_license_id || '',
                        factory_license_sequence: license.factory_license_sequence,
                        factory_detail: license.factory_detail || ''
                    }));

                    this.org_business_detail = [
                        {
                            org_business_condition: (data.orgBusinessDataDetail && data.orgBusinessDataDetail.org_business_condition) || '',
                            activity_name: (data.orgBusinessDataDetail && data.orgBusinessDataDetail.activity_name) || '',
                            org_business_status: (data.orgBusinessDataDetail && data.orgBusinessDataDetail.org_business_status) || '',
                            risk_level: (data.orgBusinessDataDetail && data.orgBusinessDataDetail.risk_level) || '',
                            remark: (data.orgBusinessDataDetail && data.orgBusinessDataDetail.remark) || ''
                        }
                    ];

                    // console.log('Organization Business Details:', this.org_business_detail);

                    // Map the parents data
                    this.hspTableData = data.hspLicense || [];

                    // Map the referral persons data
                    this.factoryTableData = data.factoryLicense || [];

                    // Map the education data
                    this.orgBusinessDetailTableData = data.orgBusinessDetail || [];

                    // Remove existing focus
                    document.activeElement.blur();

                    // Set focus to the first input field
                    this.$nextTick(() => {
                        this.$refs.TextBox_1.focus();
                    });

                    // Set the form to edit mode
                    this.isEditMode = true;
                    if (this.isEditMode === true) {
                        this.header = this.$i18n.t('public_organize_modal_title_edit');
                    }
                } else {
                    console.error('No data found for the given org_id');
                }
            } catch (error) {
                console.error('Error fetching organization data:', error);
            }
        },

        async saveEditPublicOrganization() {
            this.isEditMode = false;

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            this.$fire({
                title: 'ยืนยันการสร้างข้อมูล',
                text: 'คุณต้องการสร้างข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const username = this.decodeJWT.user_username;
                        const response_organize = this.imp_organize?.name || ''; // Ensure imp_organize name is included

                        const orgBusinessDataDetail = {
                            response_organize: response_organize,
                            org_id: 'org-' + Date.now(),
                            org_name: this.org_name,
                            org_owner_name: this.org_owner_name,
                            org_address: this.io_location_detail,
                            org_tel: this.contact_phone_office,
                            activity_name: this.activity_name,
                            org_coordinator_name: this.org_coordinator_name,
                            io_lat: this.io_lat,
                            io_lon: this.io_lon,
                            date_create_form: currentDateString,
                            date_update_form: currentDateString,
                            created_by: username, // Replace with actual user ID if available
                            updated_by: username, // Replace with actual user ID if available
                            flag: '1',
                            io_location_detail: this.io_location_detail,
                            contact_phone_office: this.contact_phone_office,
                            contact_phone: this.contact_phone,
                            FireStationSelected: this.FireStationSelected.fs_tname || null,
                            io_selectedProvince: this.io_selectedProvince.province_name,
                            io_selectedAmphur: this.io_selectedAmphur.amphur_name,
                            io_selectedTambon: this.io_selectedTambon.tambon_name,
                            io_postcode: this.io_postcode,
                            RiskLevel_type: this.RiskLevel_type,
                            business_id: 'BID-' + Date.now()
                        };

                        const hspLicense = this.hspTableData.map((hsp) => ({
                            hsp_license_id: hsp.hsp_license_id,
                            hsp_license_sequence: hsp.hsp_license_sequence,
                            hsp_expire_date: formatDate(hsp.hsp_expire_date),
                            hsp_type: hsp.hsp_type,
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1',
                            org_id: orgBusinessDataDetail.org_id,
                            business_id: orgBusinessDataDetail.business_id
                        }));

                        const factoryLicense = this.factoryTableData.map((factory) => ({
                            factory_license_id: factory.factory_license_id,
                            factory_license_sequence: factory.factory_license_sequence,
                            factory_detail: factory.factory_detail,
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1',
                            org_id: orgBusinessDataDetail.org_id,
                            business_id: orgBusinessDataDetail.business_id
                        }));

                        const orgBusinessDetail = this.orgBusinessDetailTableData.map((detail) => ({
                            org_business_condition: detail.org_business_condition,
                            activity_name: detail.activity_name,
                            org_business_status: detail.org_business_status,
                            risk_level: detail.risk_level,
                            remark: detail.remark || ''
                        }));

                        const businessLicenseData = {
                            business_id: 'bid-' + Date.now(),
                            org_id: orgBusinessDataDetail.org_id,
                            factory_license_id: factoryLicense.map((fl) => fl.factory_license_id),
                            hsp_license_id: hspLicense.map((hl) => hl.hsp_license_id),
                            date_create: currentDateString,
                            date_update: currentDateString,
                            created_by: username,
                            updated_by: username,
                            flag: '1'
                        };

                        const payload = {
                            orgBusinessDataDetail,
                            hspLicense,
                            factoryLicense,
                            orgBusinessDetail,
                            businessLicenseData
                        };

                        // console.log('payload', payload);

                        this.loadingCreate = true;
                        const response = await fetch(`${this.$url_service}/post/organization/detail`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            throw new Error(`Network response was not ok: ${response.statusText}`);
                        }

                        const data = await response.json();
                        // console.log('Organization detail posted successfully:', data);

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกบันทึกเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        });
                    } catch (error) {
                        console.error('Error posting organization detail:', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการบันทึกข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingCreate = false;
                    }
                }
            });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            this.multiSelectClearFilerValue += 1;

            (this.org_owner_name = ''),
                (this.org_name = ''),
                (this.FireStationSelected = null),
                (this.io_location_detail = ''),
                (this.io_selectedProvince = null),
                (this.io_selectedAmphur = null),
                (this.io_selectedTambon = null),
                (this.io_postcode = ''),
                (this.contact_phone_office = ''),
                (this.contact_phone_office = ''),
                (this.contact_phone = ''),
                (this.org_coordinator_name = ''),
                (this.RiskLevel_type = null),
                (this.io_lat = ''),
                (this.io_lon = ''),
                (this.orgBusinessDetailTableData = []);
            this.org_business_condition = null;
            this.activity_name = null;
            this.org_business_status = null;
            this.risk_level = null;
            this.remark = '';

            this.hsp_license_id = '';
            this.hsp_license_sequence = '';
            this.hsp_expire_date = '';
            this.hsp_type = '';
            this.hsp_sequence = '';
            this.hspTableData = [];

            this.factoryTableData = [];
            this.factory_license_id = '';
            this.factory_license_sequence = '';
            this.factory_detail = '';
            this.factory_sequence = '';
            this.horse_power = '';
            this.total_worker = '';
            this.men_worker = '';
            this.women_worker = '';

            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('public_org_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.organizationInfoModal = false;
                this.selectedData = '';
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.imp_organize = {};
            this.error_imp_organize = false;
            this.error_org_owner_name = false;
            this.error_org_name = false;
            this.error_fireStation = false;
            this.error_io_location_detail = false;
            this.error_io_selectedProvince = false;
            this.error_io_selectedAmphur = false;
            this.error_io_selectedTambon = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone = false;
            this.error_org_coordinator_name = false;
            this.error_RiskLevel_type = false;
            this.error_org_business_condition = false;
            this.error_activity_name = false;
            this.error_org_business_status = false;
            this.error_risk_level = false;
            this.error_remark = false;
            this.error_hsp_license_id = false;
            this.error_hsp_sequence = false;
            this.error_hsp_expire_date = false;
            this.error_hsp_type = false;
            this.error_hsp_sequence = false;
            this.error_factory_license_id = false;
            this.error_factory_license_sequence = false;
            this.error_factory_detail = false;
            this.error_factory_sequence = false;
            this.error_org_business_detail = false;

            this.tempFor_displayConfirmationCloseModal = '';
            this.url = null;
            document.getElementById('organize_uploadImageFile').value = '';
            this.org_name = '';
            this.io_location_detail = '';
            this.org_owner_name = '';
            this.fireStation = null;
            this.io_selectedOrganize = {};
            this.io_selectedProvince = null;
            this.contact_phone_office = '';
            this.io_fax = '';
            this.org_coordinator_name = '';
            this.io_website = '';
            this.io_contact_name = '';
            this.io_contact_phone = '';
            this.io_lat = '';
            this.io_lon = '';
            this.io_selectedDisaster = null;
            this.disaster_table = [];
            this.hspTableData = [];
            this.communication_table = [];
            this.error_org_name = false;
            this.error_fireStation = false;
            this.error_io_selectedProvince = false;
            this.error_io_selectedAmphur = false;
            this.error_io_selectedTambon = false;
            this.error_email_format = false;

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.date_create_form = '';
            this.date_update_form = '';
            this.horse_power = '';
            this.total_worker = '';
            this.men_worker = '';
            this.women_worker = '';
        },

        async clearSearchField() {
            this.check_update_info = [];
            this.error_check_update_info = false;
            this.public_org_name = '';
            this.public_org_owner_name = '';
            this.orgId = '';
            this.permission_id = '';
            this.RiskLevel_type = null;
            this.org_business_condition = null;
            this.activity_name = null;

            this.org_business_status = null;

            this.organizeTypeSelect = null;
            this.selectedOrganize = {};
            this.selectedProvince = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.organize_table = [];
            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
            this.isEditMode = false;
            this.clearData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.check_update_info = [];
                this.error_check_update_info = false;
                this.public_org_name = '';
                this.organizeTypeSelect = null;
                this.selectedOrganize = {};
                this.selectedProvince = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.organize_table = [];
                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        // Doe :   เพิ่ม มุดmap 4/4
        sendM(io_lat, io_lon) {
            let lat = io_lat;
            let lon = io_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province, FireStationSelected) {
            if (FireStationSelected) {
                this.FSS = FireStationSelected;
            } else {
                this.FSS = {};
            }

            if (tambon) {
                this.PAT = tambon;
            } else if (amphur) {
                this.PAT = amphur;
            } else if (province) {
                this.PAT = province;
            } else {
                this.PAT = {};
            }
        },
        //  Doe เพิ่มหมุด map V.2 7/8  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.io_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.io_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.io_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                // if(land_ID == "00"){
                //   this.error_latlon_land = true
                // }else{
                //   this.error_latlon_land = false
                // }

                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.io_selectedProvince = null;
                this.io_selectedAmphur = null;
                this.io_selectedTambon = null;
            }

            // console.log("receiveM_PAT-------------------")
            // console.log("country_ID",country_ID)
            // console.log("land_ID",land_ID)
            // console.log("this.io_selectedProvince",this.io_selectedProvince)
            // console.log("this.io_selectedAmphur",this.io_selectedAmphur)
            // console.log("this.io_selectedTambon",this.io_selectedTambon)
        },
        //  Doe เพิ่มหมุด map V.2 7/8  จบ-->
        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 11;
                this.PDF_FontBodyVer = 8;

                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 70;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 10;
                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_img = false;
                this.columns_public_org_name = false;
                this.columns_system_name = false;
                this.columns_main_name = false;
                this.columns_organize_location = false;
                this.columns_event_lat = false;
                this.columns_event_lon = false;
                this.columns_organize_contact_name = false;
                this.columns_organize_contact_phone = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'organize_image') {
                        this.columns_img = true;
                    } else if (!getData.includes('organize_image')) {
                        this.columns_img = false;
                    }

                    if (element == 'public_org_name') {
                        this.columns_public_org_name = true;
                    } else if (!getData.includes('public_org_name')) {
                        this.columns_public_org_name = false;
                    }

                    if (element == 'system_name') {
                        this.columns_system_name = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_system_name = false;
                    }

                    if (element == 'main_name') {
                        this.columns_main_name = true;
                    } else if (!getData.includes('main_name')) {
                        this.columns_main_name = false;
                    }

                    if (element == 'organize_location') {
                        this.columns_organize_location = true;
                    } else if (!getData.includes('organize_location')) {
                        this.columns_organize_location = false;
                    }

                    if (element == 'organize_lat') {
                        this.columns_event_lat = true;
                    } else if (!getData.includes('organize_lat')) {
                        this.columns_event_lat = false;
                    }

                    if (element == 'organize_lon') {
                        this.columns_event_lon = true;
                    } else if (!getData.includes('organize_lon')) {
                        this.columns_event_lon = false;
                    }

                    if (element == 'organize_contact_name') {
                        this.columns_organize_contact_name = true;
                    } else if (!getData.includes('organize_contact_name')) {
                        this.columns_organize_contact_name = false;
                    }

                    // if (element == "organize_contact_phone") {
                    //   this.columns_organize_contact_phone = true
                    // } else if(!getData.includes("organize_contact_phone")){
                    //   this.columns_organize_contact_phone = false
                    // }
                    // if (element == 'text_tel_detail') {
                    //     this.columns_organize_contact_phone = true;
                    // } else if (!getData.includes('text_tel_detail')) {
                    //     this.columns_organize_contact_phone = false;
                    // }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
/*   Doe เพิ่มหมุด map V.2 8/8  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 8/8  จบ--> */
.table_row {
    text-align: center;
}
.imgDia {
    width: 100%;
    display: block;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
        #Create{
        width: 146px;
      }
     
  } */
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }

    .Or_disasterOptions {
        width: 14.5rem;
        overflow-y: scroll;
    }
    .Or_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .Or_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .Or_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}
.p-field {
    margin-bottom: 0rem;
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    /* height: 180px; */
    width: 234px;
    border: solid 1px #cccccc;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
